import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {userActions} from "./userSlice";
import {userApi} from "~/api";

function* fetchDemoList(action) {
	try {
		const response = yield call(userApi.gets, action.payload);
		yield put(userActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch user list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(userActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(userActions.setFilter(action.payload));
}

export default function* userSaga() {
	yield takeLatest(userActions.fetchData.type, fetchDemoList);
	yield debounce(500, userActions.setFilterWithDebounce.type, handleSearchDebounce)
}